import { Dispatch } from 'redux'
import { ClientsService } from '../../../services/clients.service';

export const getClients: any = (requestParams: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'GET_CLIENTS_LOADING' });
        const res = await ClientsService.getClients({ data: requestParams });
        dispatch({ type: 'GET_CLIENTS_SUCCESS', payload: res.value });
    } catch(e: any) {
        dispatch({ type: 'GET_CLIENTS_ERROR' });
        throw e;
    }
}

export const addClient: any = (requestParams: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'ADD_CLIENT_LOADING' });
        const res = await ClientsService.addClient({ ...requestParams });
        dispatch({ type: 'ADD_CLIENT_SUCCESS', payload: res.value });
    } catch(e: any) {
        dispatch({ type: 'ADD_CLIENT_ERROR' });
        throw e;
    }
}

export const deleteClient: any = (clientName: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'DELETE_CLIENT_LOADING' });
        const res = await ClientsService.deleteClient({ 'Client Name': clientName });
        dispatch({ type: 'DELETE_CLIENT_SUCCESS', payload: res.value });
    } catch(e: any) {
        dispatch({ type: 'DELETE_CLIENT_ERROR' });
        throw e;
    }
}